export * from '@fhs/routing/src/routes/(tabs)/rewards/offers/[incentiveId]';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/offers/[incentiveId]';
